import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './styles/element.scss';
import 'highlight.js/styles/stackoverflow-light.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import feedback from './utils/feedback';
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}
// 全局注册 copyCode 函数
if (typeof window !== 'undefined') {
    window.copyCode = function (event) {
        // 从按钮中获取 `data-code` 属性值
        const datas = event.getAttribute('data-code');
        const code = JSON.parse(decodeURIComponent(datas));
        if (navigator.clipboard) {
            navigator.clipboard.writeText(code).then(() => {
                feedback.msgSuccess('复制成功');
            }).catch(err => {
                feedback.msgError('复制失败，尝试手动复制');
            });
        }
        else {
            // 兼容不支持 Clipboard API 的浏览器
            const textarea = document.createElement('textarea');
            textarea.value = code;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            feedback.msgSuccess('复制成功');
        }
    };
}
app.use(ElementPlus).use(store).use(router).mount('#app');
